module.exports = __webpack_public_path__ + "static/media/bulk_student_create.b1e9c2b8.csv";